import api from './api';

// Talks to /api/price-indices/* — the volatile prices that move rates across
// distribution. Version comes from the x-budget-version-id header (set by the
// api interceptor).
//
// NOT site-scoped, unlike every other distribution service: diesel does not
// have a depot, and the impact figures returned cover the whole tenant.
export const priceIndexService = {
  // { indices: [{ index_code, index_name, uom, default_base_value, is_active,
  //               values: [12], linked_lines,
  //               impact: { budget_amount, index_adjustment,
  //                         sensitivity_per_unit, by_source } }] }
  //
  // linked_lines is the answer to "I changed diesel and nothing moved": an
  // index nothing links to is inert, and the page says so out loud.
  getIndices: async () => {
    const res = await api.get('/price-indices');
    return res.data;
  },

  // The index MASTER — cross-version, admin to write. A rename here rewrites
  // scenarios nobody is looking at, which is why it is gated.
  saveIndices: async (indices) => {
    const res = await api.put('/price-indices', { indices });
    return res.data;
  },

  // The twelve monthly prices for THIS version. Not admin-gated: revising a
  // diesel forecast for an LE is the planner's ordinary work.
  // values: [{ index_code, values: [12] }]
  saveValues: async (values) => {
    const res = await api.put('/price-indices/values', { values });
    return res.data;
  },

  deleteIndex: async (indexCode) => {
    const res = await api.delete(`/price-indices/${encodeURIComponent(indexCode)}`);
    return res.data;
  },

  // "What if diesel were R25?" — EXACT, not a model re-run. Cost is linear in
  // the index by construction, so the derivative the cost views carry gives the
  // real answer rather than an approximation.
  getImpact: async (indexCode, value) => {
    const res = await api.get('/price-indices/impact', { params: { index_code: indexCode, value } });
    return res.data;
  },
};

export default priceIndexService;
